import * as React from "react";
import styled, { css } from "styled-components";

import Grid from "src/library/components/Hedron";
import { BrandSplitView } from "src/library/components/BrandSplitView";
import { Text } from "src/library/components/Text";
import { Logo } from "src/core/shared/components/Logo";
import { PageProps } from "src/pages/Router/routes";

/**
 * 404 Not Found View
 *
 * @param {*} { history }
 * @returns
 */
const SuspendedPage: React.ReactFCWithChildren<PageProps<unknown>> = () => {
  return (
    <BrandSplitView>
      <LogoutInner>
        <Grid.Box className="logo-wrapper">
          <Logo type="dark" />
        </Grid.Box>

        <>
          <PaddedContainer>
            <Text
              color="secondary"
              fontSize="p"
            >
              Your account has been suspended. Please contact an adminstrator.
            </Text>
          </PaddedContainer>

        </>

      </LogoutInner>
    </BrandSplitView>
  );
};

const PaddedContainer = styled(Grid.Box)`
  ${({ theme }) =>
    css`
      padding-top: ${theme.spacing.padding.xl};
    `};
`;

const LogoutInner = styled(Grid.Bounds)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  ${({ theme }) =>
    css`
      padding: ${theme.spacing.padding.xl};
      padding-bottom: ${theme.spacing.padding.md};
  `};

  .logo-wrapper {
    max-width: 400px;
  }
`;

export default SuspendedPage;
